export default __webpack_public_path__ + "static/media/github-icon.f79f5873.svg";